function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 85.331h512v341.337H0z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M318.33 255.994c0 15.583-27.906 54.539-62.33 54.539s-62.33-38.957-62.33-54.539c0-34.424 27.906-62.33 62.33-62.33s62.33 27.906 62.33 62.33z",
  fill: "#d80027"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M318.33 255.994c0 34.424-27.906 62.33-62.33 62.33s-62.33-27.906-62.33-62.33",
  fill: "#0052b4"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M322.114 311.096l16.528-16.528 11.018 11.018-16.528 16.528zm-27.548 27.534l16.528-16.527 11.018 11.018-16.528 16.528zm60.604 5.502l16.527-16.528 11.018 11.018-16.527 16.528zm-27.549 27.557l16.528-16.528 11.018 11.018-16.528 16.528zm11.02-44.075l16.528-16.527 11.018 11.018-16.527 16.527zm-27.547 27.546l16.528-16.528 11.018 11.018-16.528 16.527zm44.083-154.264l-44.073-44.073 11.018-11.018 44.073 44.073zm-44.078-11.015l-16.528-16.527 11.017-11.018 16.528 16.528zm27.536 27.55l-16.528-16.527 11.017-11.018 16.528 16.528zm5.5-60.606l-16.528-16.528 11.018-11.018 16.528 16.528zm27.559 27.549l-16.528-16.527 11.019-11.019 16.527 16.528zM140.31 327.61l44.073 44.074-11.018 11.018-44.074-44.073zm44.058 11.025l16.527 16.527-11.017 11.018-16.528-16.528zm-27.536-27.548l16.528 16.528-11.019 11.018-16.527-16.528zm16.531-16.523l44.073 44.073-11.018 11.019-44.073-44.074zm11.021-154.277l-44.073 44.074-11.018-11.018 44.073-44.074zm16.511 16.536l-44.073 44.074-11.018-11.018 44.073-44.074zm16.529 16.528l-44.074 44.074-11.017-11.017 44.074-44.074z"
});

const SvgSouthKorea = (_ref) => {
  let svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 512 512",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSouthKorea, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/south-korea.ce82a64d.svg";
export { ForwardRef as ReactComponent };